import { localizer } from "../../Translator"

export default class StateCodes {
  static get CODES() {
    return [
      { "stateCode": "CAN", "name": localizer.InboxStateCAN, "end": true },
      { "stateCode": "DEL", "name": localizer.InboxStateDEL, "end": true },
      { "stateCode": "DIE", "name": localizer.InboxStateDIE, "end": true },
      { "stateCode": "DLD", "name": localizer.InboxStateDLD, "end": true },
      { "stateCode": "DLO", "name": localizer.InboxStateDLO, "end": true },
      { "stateCode": "EPD", "name": localizer.InboxStateEPD, "end": true },
      { "stateCode": "EPR", "name": localizer.InboxStateEPR, "end": true },
      { "stateCode": "EXP", "name": localizer.InboxStateEXP, "end": true },
      //{ "stateCode": "IN", "name": localizer.InboxStateIN,"end":false },
      { "stateCode": "LST", "name": localizer.InboxStateLST, "end": true },
      { "stateCode": "NIF", "name": localizer.InboxStateNIF, "end": false },
      { "stateCode": "NRC", "name": localizer.InboxStateNRC, "end": false },
      { "stateCode": "OND", "name": localizer.InboxStateOND, "end": false },
      { "stateCode": "OTH", "name": localizer.InboxStateOTH, "end": false },
      { "stateCode": "OUT", "name": localizer.InboxStateOUT, "end": false },
      { "stateCode": "PRE", "name": localizer.InboxStatePRE, "end": false },
      { "stateCode": "PRI", "name": localizer.InboxStatePRI, "end": false },
      { "stateCode": "RET", "name": localizer.InboxStateRET, "end": true },//return
      { "stateCode": "RJT", "name": localizer.InboxStateRJT, "end": true },
      { "stateCode": "REJ", "name": localizer.InboxStateREJ, "end": true },
      { "stateCode": "RPO", "name": localizer.InboxStateRPO, "end": false },
      { "stateCode": "SH", "name": localizer.InboxStateSH, "end": false },
      { "stateCode": "SPR", "name": localizer.InboxStateSPR, "end": false },
      { "stateCode": "STL", "name": localizer.InboxStateSTL, "end": true },
      { "stateCode": "UNK", "name": localizer.InboxStateUNK, "end": true },
      { "stateCode": "UP", "name": localizer.InboxStateUP, "end": false },
      { "stateCode": "WAD", "name": localizer.InboxStateWAD, "end": true },
      { "stateCode": "WAY", "name": localizer.InboxStateWAY, "end": false },
      { "stateCode": "SNT", "name": localizer.InboxDateEmission, "end": false },
      { "stateCode": "PRG", "name": localizer.InboxDateProgrammed, "end": false }
    ]
  }
  static get FILTER_CODES() {
    return [
      { "stateCode":  ["DEL", "DLD","DLO","EPD"], "name": localizer.InboxStateDEL, "end": true },//delivered
      // REJ is intentionally grouped under "Incorrect address" in the outbox interface, as this is the most common reason for rejection by the postal operator.
      // Operationally, Telegraf REJ is commonly linked to invalid/unknown postal code or destination data.
      // The backend also treats REJ as a distinct status code; this grouping is solely a UX or business decision for filtering purposes.
      { "stateCode": ["EPR-WAD", "RET-WAD", "REJ"], "name": localizer.InboxStateWAD, "end": true },//wrong address--REJ: Rejected by the postal operator by telegraf
      { "stateCode": ["EPR-UNK","RET-UNK"], "name": localizer.InboxStateUNK, "end": true },//Unknown
      { "stateCode": ["EPR-DIE", "RET-DIE"], "name": localizer.InboxStateDIE, "end": true },//Died      
      { "stateCode": ["EPR-SOB","RET-SOB"], "name": localizer.InboxStateSOB, "end": true },//Sobrante (No retirado en oficina) other types may need to be added
      { "stateCode": ["RJT","EPR-RJT"], "name": localizer.InboxStateRJT, "end": true },//Rejected by destination
      { "stateCode": ["WAY","SNT","OND","SH","SPR","PRI","PRE","PRG","RPO","UP","NRC"], "name": localizer.InboxStateINP, "end": false },//In progress--everything not finished
      { "stateCode": ["OTH", "CAN", "OUT", "LST", "NIF", "STL", "EXP"], "name": localizer.InboxStateOTH, "end": true },   //others: everything that does not fit with the above
    ]
  }

}



// WEBPACK FOOTER //
// ./src/components/Utilities/StateCodes.js